import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'

export const BannerContainer = styled.div`
  background-color: ${(props) => (props.displayLovevery ? '#CCF0E7' : '#417978')};
  padding: 16px 32px 8px;
  text-align: center;
  @media (max-width: ${breakpoints.s}px) {
    width: ${(props) => (props.cal ? '120%' : '111%')};
    position: relative;
    left: -6%;
    margin-top: 16px;
    padding: 16px 12px 8px;
  }
`
export const TextContainer = styled.div`
  margin: auto;
  color: ${(props) => (props.displayLovevery ? '#093642' : '#fffbf3')};
  @media (max-width: ${breakpoints.s}px) {
    width: 100%;
  }
`
export const SubLabel = styled.h3`
  color: ${(props) => (props.displayLovevery ? '#093642' : '#fffbf3')};
  font-family: 'FilsonProMedium';
  margin: 8px 0px 8px;
  font-size: 24px;
  line-height: 1.2;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 18px;
    margin: 8px 0px 4px;
  }
  @media (max-width: 360px) {
    font-size: 16px;
  }
`
export const Disclosure = styled.p`
  margin-top: 0px;
  line-height: 1.2;
  letter-spacing: 0.11px;
  font-family: 'FilsonPro';
  span {
    text-decoration: underline;
    font-family: 'FilsonProBold';
  }
  @media (max-width: ${breakpoints.s}px) {
    margin-top: 8px;
    font-size: 14px;
  }
`
export const BetterHelpImageContainer = styled.div`
  width: 300px;
  margin: auto;
  @media (max-width: ${breakpoints.m}px) {
    width: 200px;
  }
`
